class AppError extends Error {
  constructor({ title, response, userMessage }) {
    super(userMessage);
    this.title = title || "Error";
    this.response = response || null;
    this.userMessage = userMessage || "Something went wrong.";
  }

  toJSON() {
    return {
      title: this.title,
      response: this.response,
      userMessage: this.userMessage,
    };
  }

  static fromAPIError(response) {
    return new AppError({
      title: "API Error",
      response,
      userMessage:
        response?.data?.userMessage || "An unexpected error occurred.",
    });
  }
}

export default AppError;
